// extracted by mini-css-extract-plugin
export default {"CatalogItemContainer":"CatalogItemContainer_CatalogItemContainer__E1FNo","CatalogItemContainerBottom":"CatalogItemContainer_CatalogItemContainerBottom__-TWOM"};